import React, {FC} from 'react';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';

import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LayersIcon from '@mui/icons-material/Layers';
import ListProject from '@mui/icons-material/PowerSettingsNew';
import ZoneData from '@mui/icons-material/Dns';

import {Stats} from '@/domain/entities/Stats';

import {useTranslation} from 'react-i18next';
import {Mode} from '@/components/Layout';

export enum ButtonPanelMode {
  PARCEL= 'parcel',
  SETTINGS = 'settings',
  PROFILE = 'profile',
  ZONE_DATA = 'zoneData'
}

type ButtonPanelProps = {
  selectedParcelUuid?: string,
  mode?: Mode,
  stats?: Stats,
  onModeChanged: (mode?: Mode) => void
  onAboutClicked: () => void
  onProjectListClicked: () => void
}

const ButtonPanel: FC<ButtonPanelProps> = ({
  selectedParcelUuid,
  mode,
  stats,
  onModeChanged,
  onAboutClicked,
  onProjectListClicked
}) => {

  const {t} = useTranslation();

  const handleModeChanged = (buttonMode: Mode) =>
    onModeChanged(mode === buttonMode ? undefined : buttonMode);

  const handleProjectListClicked = () => {
    onModeChanged(undefined);
    onProjectListClicked();
  };

  const buttonsDisabled = mode === Mode.PARCEL;

  return <Paper elevation={7} sx={styles.paper}>
    <Stack>

      <Tooltip title={t('button.parcel')} placement="right">
        <span>
          <IconButton sx={styles.iconButton} disabled={!selectedParcelUuid}>
            {selectedParcelUuid ? <LocationOnIcon sx={styles.selectedIconButton}/> : <LocationOnIcon/>}
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={t('button.zoneData')} placement="right">
        <IconButton sx={styles.iconButton} onClick={() => handleModeChanged(Mode.ZONE_DATA)} disabled={buttonsDisabled || !stats}>
          {mode === Mode.ZONE_DATA ? <ZoneData sx={styles.selectedIconButton}/> : <ZoneData/>}
        </IconButton>
      </Tooltip>

      <Tooltip title={t('button.layers')} placement="right">
        <IconButton disabled={buttonsDisabled} sx={styles.iconButton} onClick={() => handleModeChanged(Mode.SETTINGS)}>
          {mode === Mode.SETTINGS ? <LayersIcon sx={styles.selectedIconButton}/> : <LayersIcon/>}
        </IconButton>
      </Tooltip>
      
      <Divider sx={{my: 2}}/>
    

      <Tooltip title={t('button.profile')} placement="right">
        <IconButton disabled={buttonsDisabled} sx={styles.iconButton} onClick={() => handleModeChanged(Mode.PROFILE)}>
          {mode === Mode.PROFILE ? <PersonIcon sx={styles.selectedIconButton}/> : <PersonIcon/>}
        </IconButton>
      </Tooltip>

      <Tooltip title={t('button.exitProject')} placement="right">
        <IconButton disabled={buttonsDisabled} sx={styles.iconButton} onClick={handleProjectListClicked}>
          <ListProject/>
        </IconButton>
      </Tooltip>

    </Stack>
    <Tooltip title={t('button.about')} placement="right">
      <IconButton disabled={buttonsDisabled} sx={styles.iconButton} onClick={onAboutClicked}>
        <InfoIcon/>
      </IconButton>
    </Tooltip>
  </Paper>;
};
export default ButtonPanel;

const styles = {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '1px solid lightgrey',
    width: '52px',
    borderRadius: '8px',
    opacity: 0.95,
    position: 'absolute',
    top: 'calc(28px + 50%)',
    transform: 'translateY(-50%)',
    left: 8,
    zIndex: 200
  },
  iconButton: {
    my: 1
  },
  selectedIconButton: {
    color:'primary.main'
  }
};